<template>
  <vx-card class="overflow-hidden mb-base" title="Statistiques globales" collapse-action>
    <template slot="no-body">
      <div class="p-6">
        <div class="vx-row">
          <div class="vx-col w-full md:w-3/4 mb-base">
            <vue-apex-charts v-if="!loading"
              type="area"
              height="360"
              :options="requestsSummaryCharts.options"
              :series="requestsSummaryCharts.series"/>
          </div>
          <div
            class="border border-b-0 border-r-0 border-solid border-t-0 d-theme-border-grey-light flex flex-col justify-between mb-base md:w-1/4 vx-col w-full">
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Toutes mes demandes</p>
              <p class="text-3xl">{{counts.total_my_request}}</p>
            </div>
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Demandes clôturées</p>
              <p class="text-3xl">{{counts.total_closed_request}}</p>
            </div>
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Demandes rejettées</p>
              <p class="text-3xl">{{counts.total_rejected_request}}</p>
            </div>
            <div class="border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-l-0">
              <p class="mb-1 font-semibold">Demandes en traitement</p>
              <p class="text-3xl">{{counts.total_on_treat}}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';

  export default {
    name: "last6MonthsStats",
    components: {VueApexCharts},
    data: () => ({
      last_6: 1,
      loading: false,
      counts: {
        total_my_request: 11,
        total_closed_request: 1,
        total_rejected_request: 0,
        total_on_treat: 1
      },
      requestsSummaryCharts: {
        options: {
          title: {
            text: 'Demandes des 6 derniers mois',
            align: 'left'
          },
          stroke: {
            curve: 'straight'
          },
          colors: ['#008ffa', '#067A2F', '#ff0003'],
          xaxis: {
            categories: [],
          },
        },
        series: [ ]
      },
    }),
    methods: {
      getRequestsCount() {
        this.$vs.loading()
        this.$http.get('statistics/cc?last6=' + this.last_6).then((response) => {
          this.counts = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      getLast6MonthsStats(){
        this.loading = true
        this.$vs.loading()
        this.$http.get('/statistics/cc/graph-of-last6m').then((response) => {
          let datas = response.data;
          this.requestsSummaryCharts.series = []
          this.requestsSummaryCharts.options.xaxis.categories = []
          //setup graph
          this.requestsSummaryCharts.options.xaxis.categories = datas.months
          datas.graph.forEach((data) => {
            this.requestsSummaryCharts.series.push({
              name: data.name,
              data: data.data
            })
          })

          this.$vs.loading.close()
          this.loading = false
        }).catch((error) => {
          this.loading = false
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      }
    },
    mounted() {
      this.getRequestsCount();
      this.getLast6MonthsStats()
    }
  }
</script>

<style scoped>

</style>
